import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Highcharts from "@material-ui/core/es/styles/withStyles";
import blue from "@material-ui/core/es/colors/blue";
import grey from "@material-ui/core/es/colors/grey";
import {COLOR_chart_series_first_line} from "../../../common/CustomTheme/ThemeDefault/colors";

HighchartsMore(ReactHighcharts.Highcharts);


var config =  {
    chart: {
        type: 'column',

    },
    title: {
        text: 'Consumo de energia'
    },

    yAxis: {
        min:0,

        title: {
            text: 'kWh'
        },
        labels: {
            enabled: true
        }
    },
    legend: {
        enabled: false
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
     series: []

}

export default function RaspaCycleDistributionOnHourEnergyChart(prop) {
    const { series, filter } = prop;

    let configs = [];

    if (series) {
        let hourSeriesArray = [];
        let categories = [];
        let first = true;
        let auxd = '';

        series.map( i => {

            let d = new Date(i.Data).toISOString().slice(0, 10)+' '+i.Hora + 'h';

            categories.push(d);
            hourSeriesArray.push(i.EnergiakWh ? i.EnergiakWh : 0);

        });


            config = {
                ...config,
                xAxis: {
                    categories: categories,
                    title: {
                        text: 'Dia'
                    },
                    labels: {
                        format: '{value}',
                        enabled: true
                    }
                },

                series: [
                    {
                       name: 'Energia kWh',
                        data: hourSeriesArray,
                        color: COLOR_chart_series_first_line
                    }]

            }

    }

    return (
        <Card title="laos">
           <ReactHighcharts config = {config}>
                            </ReactHighcharts>

        </Card>
    )
}
